export default "__VITE_ASSET__a9203ef8__"